<script>
  import { browser } from "$app/environment";
  import gql from "graphql-tag";
  import { linkResolver } from "$lib/prismic";

  import Image from "../Image.svelte";
  import Headlines from "./Headlines.svelte";

  import { client } from "$lib/apollo";

  export let block;

  let width = browser ? window.innerWidth : 1920;
  let height = browser ? window.innerHeight : 1080;
  const breakpoint = 1024;

  $: images = block.fields.map((field, index) => {
    const image = field?.case?.image;
    if (!image) return;
    if (
      (width > breakpoint && index % 4 < 2) ||
      (width <= breakpoint && width > height)
    )
      return image;

    const portrait = Object.fromEntries(
      Object.entries(image)
        .filter(([key]) => key.indexOf("portrait-") === 0)
        .map(([key, value]) => [key.replace("portrait-", ""), value]),
    );
    return {
      ...portrait,
      ...portrait.main,
    };
  });

  const resize = () => {
    window.requestAnimationFrame(() => {
      width = window.innerWidth;
      height = window.innerHeight;
    });
  };

  /* Pagination */

  let query = gql`
    query cases($cursor: String, $first: Int) {
      allCases(where: { highlighted: false }, after: $cursor, first: $first) {
        edges {
          cursor
          node {
            headline
            subline
            image
            _meta {
              uid
              type
            }
          }
        }
        pageInfo {
          hasNextPage
        }
      }
    }
  `;

  let cursor = null;
  let first = 1;
  let debounce = false;

  const next = async () => {
    if (debounce) return;
    debounce = true;
    const mod = block.fields.length % 6;
    first = mod === 0 || mod === 4 ? 2 : 1;
    const { data } = await client.query({
      query,
      variables: {
        cursor,
        first,
      },
    });
    // Only debounce if nextPage is available
    debounce = !data.allCases.pageInfo.hasNextPage;
    const edges = data.allCases.edges;
    if (!edges.length) return;
    cursor = edges[edges.length - 1].cursor;
    block.fields = [
      ...block.fields,
      ...edges.map((edge) => ({ case: edge.node })),
    ];
  };
</script>

<svelte:window on:resize={resize} />
{#if block.primary.tiles}
  <div
    class="py-16 {block.primary.background ? 'dark' : 'light'}"
    class:pattern={block.primary.pattern}
  >
    <div class="max-w-content mx-auto overflow-hidden">
      <div class="flex flex-wrap mx-4 xl:-mx-4">
        {#each block.fields as entry}
          {#if entry.case}
            <div class="w-full md:w-1/2 p-4">
              <a
                href={linkResolver(entry.case._meta)}
                sveltekit:prefetch
                class="block rounded overflow-hidden relative group"
              >
                <Image
                  image={entry.case.image}
                  class="transition transform duration-300 group-hover:scale-110"
                />
                <div
                  class="absolute inset-0 backdrop-filter backdrop-blur-sm p-6 bg-darkgray bg-opacity-80 flex flex-col justify-between items-start text-white opacity-0 group-hover:opacity-100 transition duration-300"
                >
                  <img
                    src={entry.case.customer.logo.url}
                    alt="Logo"
                    class="filter brightness-0 invert h-10 md:w-20"
                  />
                  <Headlines
                    headlines={{
                      headline: entry.case.headline[0],
                      subline: entry.case.subline[0],
                    }}
                  />
                </div>
              </a>
            </div>
          {/if}
        {/each}
      </div>
      <a
        class="btn mt-8 text-pink ml-8 xl:ml-0"
        href="/arbeiten"
        sveltekit:prefetch
        data-text="Alle Arbeiten">Alle Cases</a
      >
    </div>
  </div>
{:else}
  <div class="flex flex-wrap {block.primary.background ? 'dark' : 'light'}">
    {#each block.fields as entry, index}
      <a
        href={linkResolver(entry.case._meta)}
        sveltekit:prefetch
        class="block w-full relative {index % 4 > 1 ? 'lg:w-1/2' : ''}"
      >
        {#if images}<Image
            image={images[index]}
            class="max-h-case object-cover"
          />{/if}
        <div class="absolute inset-0 flex items-end text-white">
          <div
            class="p-8 lg:p-16 pt-16 lg:pt-32 w-full bg-gradient-to-b from-transparent to-darkgray"
          >
            <Headlines
              headlines={{
                headline: entry.case.headline[0],
                subline: entry.case.subline[0],
              }}
              pink={true}
              large={true}
            />
          </div>
        </div>
      </a>
    {/each}
  </div>
  <!--{#if !debounce}
    <Intersection on:intersecting={next}>
      <div class="bg-darkgray max-h-case" top={500} />
    </Intersection>
  {/if}-->
{/if}
